module.exports = __webpack_public_path__ + "static/media/10.f0515f57.png";